<template>
  <div>
    <b-card title="Filtros">
      <div>
        <b-form-checkbox
          @change="swtichAllowInactivate"
          v-model="allowInactivates"
          name="check-button"
          switch
        >
          Mostrar inativos?
        </b-form-checkbox>
      </div>
      <b-row class="justify-content-start align-items-center mb-2">
        <b-col md="10" sm="12">
          <label class="text-center font-weight-bold text-primary">
            Membros do escritório:
          </label>
          <v-select
            v-model="selectedUsers"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            placeholder="Selecione"
            :options="allOptions"
            :reduce="
              (option) => (option && option.member ? option.member.id : null)
            "
            label="user"
            @input="handleInput"
            multiple
          >
            <div slot="no-options">Área de trabalho sem usuário!</div>

            <!-- <template #list-header>
                <li
                  class="add-new-header d-flex align-items-center my-50 cursor-pointer"
                  @click="$router.push({ name: 'tipo-projeto' })"
                >
                  <feather-icon icon="PlusIcon" size="16" />
                  <span class="align-middle ml-25">Add Novo usuário</span>
                </li>
              </template> -->
            <template #option="option">
              <div
                class="d-flex align-items-center w-100"
                :style="{ borderRadius: '10px' }"
                :class="{
                  'bg-primary': selectedUsers.includes(
                    option && option.member ? option.member.id : null,
                  ),
                  'text-white': selectedUsers.includes(
                    option && option.member ? option.member.id : null,
                  ),
                }"
              >
                <div
                  class="mr-1"
                  :style="{
                    backgroundColor:
                      option && option.member && option.member.color
                        ? option.member.color
                        : '#000 ',
                    width: '20px',
                    height: '20px',
                    borderRadius: '10px',
                  }"
                ></div>
                <span>{{ option.user.username }}</span>
              </div>
            </template>
            <template #selected-option="option">
              <div class="d-flex align-items-center">
                <div
                  class="mr-1"
                  :style="{
                    backgroundColor:
                      option && option.member && option.member.color
                        ? option.member.color
                        : '#000 ',
                    width: '14px',
                    height: '14px',
                    borderRadius: '7px',
                  }"
                ></div>
                <span>{{ option.user.username }}</span>
              </div>
            </template>
          </v-select>
        </b-col>
        <b-col md="2" sm="12">
          <b-button variant="danger" class="mt-2" @click="clearAll">
            Limpar todos
          </b-button>
        </b-col>
      </b-row>
      <b-row class="mb-2 align-items-center">
        <!-- INTERVALO -->
        <b-col cols="4">
          <!-- start_date -->
          <b-form-group label="Data de Início">
            <b-form-input
              v-model="start_date"
              type="date"
              @change="getTasksBySelect()"
            />
          </b-form-group>
        </b-col>

        <b-col cols="4">
          <!-- end_date -->
          <b-form-group label="Data de Fim">
            <b-form-input
              v-model="end_date"
              type="date"
              @change="getTasksBySelect()"
            />
          </b-form-group>
        </b-col>

        <!-- <b-col cols="4" class="d-flex align-items-center mt-1">
          <b-button
            variant="primary"
            @click="allPeriodSwitch"
            class="cta"
            block
          >
            Todo Período
          </b-button>
        </b-col> -->
      </b-row>
    </b-card>

    <b-card :title="`Lista de tarefas do projeto: ${project_name}`">
      <div
        v-if="loading"
        class="d-flex justify-content-center align-items-center"
        style="height: 50vh"
      >
        <div class="spinner-border spinner-border-sm"></div>
      </div>
      <div v-show="!loading" class="mt-2" style="overflow-x: auto">
        <b-table
          ref="mytab"
          responsive="sm"
          class="text-left"
          small
          striped
          hover
          :fields="fields"
          :items="items"
          :per-page="10"
          :current-page="0"
          :busy="isBusy"
          show-empty
        >
          <template #empty>
            <div class="p-2">
              <b-alert show variant="primary">
                <p class="text-center">
                  <br />
                  Não existe <strong>Evento</strong> para o intervalo escolhido,
                  tente mudar a data para buscar novos resultados!
                </p>
                <hr />
              </b-alert>
            </div>
          </template>
          <template v-slot:cell(title)="{ item }">
            <strong>{{
              item.title
                ? item.title
                : item && item.task_title && item.task_title.task_title
                ? item.task_title.task_title.toUpperCase()
                : 'Não Associado'
            }}</strong
            ><br />
            <small>
              {{ item.notes ? 'Obs.: ' + item.notes : 'Sem descrição' }}</small
            >
          </template>
          <template v-slot:cell(project)="{ item }">
            <strong>#{{ item.project.project_code }}</strong>
            <p>{{ item.project.project_name }}</p>
          </template>
          <template v-slot:cell(actions)="props">
            <div @click="handleUpdateModal(props.item)">
              <feather-icon
                v-b-tooltip.hover.lefttop.v-primary
                title="Editar fornecedor"
                icon="EditIcon"
                size="15"
              />Editar
            </div>
          </template>
          <template v-slot:cell(username)="{ item }">
            <div>
              <div
                :style="{
                  display: 'flex',
                  alignItems: 'center',
                }"
              >
                <span
                  :style="{
                    borderRadius: '50%',
                    //   display: 'block',
                    background: item.member.color,
                    width: '10px',
                    height: '10px',
                  }"
                >
                </span>
                <p
                  :style="{
                    height: 'auto',
                    paddingLeft: '5px',
                    paddingTop: '10px',
                  }"
                >
                  {{ item.member.access.user.username }}
                </p>
              </div>
              <small>{{ item.member.access.user.email }}</small>
            </div>
          </template>

          <template v-slot:cell(date)="{ item }">
            {{ dateFormatter(item.date, 'dd/MM/yyyy') }}
          </template>
          <template v-slot:cell(start)="{ item }">
            {{ item.start.slice(0, 5) }}
          </template>
          <template v-slot:cell(end)="{ item }">
            {{ item.end.slice(0, 5) }}
          </template>
          <template v-slot:cell(comments)="{ item }">
            {{ item.notes }}
          </template>
          <template v-slot:cell(finalEstCost)="{ item }">
            <small
              >R$
              {{
                numberToMonetary(item.indirect_cost + item.direct_cost)
              }}</small
            >
          </template>
          <template v-slot:cell(finalRealCost)="{ item }">
            <small>
              R$
              {{
                numberToMonetary(
                  item.real_direct_cost + item.real_indirect_cost,
                )
              }}</small
            >
          </template>
          <template v-slot:cell(indirect_cost)="{ item }">
            <small>
              R$
              {{ numberToMonetary(item.indirect_cost) }}</small
            >
          </template>
          <template v-slot:cell(direct_cost)="{ item }">
            <small>
              R$
              {{ numberToMonetary(item.direct_cost) }}</small
            >
          </template>
          <template v-slot:cell(real_indirect_cost)="{ item }">
            <small>
              R$
              {{ numberToMonetary(item.real_indirect_cost) }}</small
            >
          </template>
          <template v-slot:cell(real_direct_cost)="{ item }">
            <small>
              R$
              {{ numberToMonetary(item.real_direct_cost) }}</small
            >
          </template>
        </b-table>

        <b-pagination
          class="justify-content-center"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          @change="getTasksBySelect"
          aria-controls="my-table"
        ></b-pagination>
      </div>
      <div class="d-flex flex-column align-items-end mr-2">
        <p><strong>Total de Tarefas:</strong> {{ totalRows }}</p>
        <p>
          <strong>Duração Total:</strong>
          {{ formatMinutesToHours(tableTotals.duration) }}
        </p>
        <p>
          <strong>Despesa Fixa Estimada:</strong> R$
          {{ numberToMonetary(tableTotals.estIndCost) }}
        </p>
        <p>
          <strong>Custo Direto Estimado:</strong> R$
          {{ numberToMonetary(tableTotals.dirEstCost) }}
        </p>
        <p>
          <strong>Custo Final Estimado:</strong> R$
          {{ numberToMonetary(tableTotals.finalEstCost) }}
        </p>

        <p>
          <strong>Despesa Fixa Real:</strong> R$
          {{ numberToMonetary(tableTotals.indRealCost) }}
        </p>
        <p>
          <strong>Custo Direto Real:</strong> R$
          {{ numberToMonetary(tableTotals.dirRealCost) }}
        </p>

        <p>
          <strong>Custo Final Real:</strong> R$
          {{ numberToMonetary(tableTotals.finalRealCost) }}
        </p>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BTable,
  BPagination,
  VBTooltip,
  BCol,
  BRow,
  BFormGroup,
  BButton,
  BFormInput,
  BFormCheckbox,
  BAlert,
} from 'bootstrap-vue';
import moment from 'moment';

// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BCard,
    BTable,
    BPagination,
    BCol,
    BRow,
    BFormGroup,
    BButton,
    BFormInput,
    BFormCheckbox,
    BAlert,
  },
  data: () => ({
    items: [],
    allowInactivates: false,
    modalNewSupplier: false,
    modalDeleteSupplier: false,
    currentPage: 1,
    isBusy: false,
    loading: true,
    perPage: 15,
    startDateWithDay: '',
    endDateWithDay: '',
    allPeriod: false,
    selectedUsers: [],
    project_name: '',

    totalRows: 0,
    start_date: moment().startOf('month').format('YYYY-MM-DD'),
    users: [],
    idArr: [],
    end_date: moment().endOf('month').format('YYYY-MM-DD'),
    fields: [
      {
        key: 'title',
        label: 'Tarefa',
        sortable: true,
        thStyle: { width: '20%' },
      },
      {
        key: 'project',
        label: 'Projeto',
        sortable: true,
        thStyle: { width: '20%' },
      },

      {
        key: 'username',
        label: 'Usuário',
        sortable: true,
      },
      {
        key: 'date',
        label: 'Data',
        sortable: true,
      },
      {
        key: 'start',
        label: 'Início',
        sortable: true,
      },
      {
        key: 'end',
        label: 'Fim',
        sortable: true,
      },
      {
        key: 'indirect_cost',
        label: 'despesa fixa estimado',
        sortable: false,
      },
      {
        key: 'direct_cost',
        label: 'Custo direto estimado',
        sortable: false,
      },
      {
        key: 'finalEstCost',
        label: 'Custo Final Estimado',
        sortable: false,
      },
      {
        key: 'real_indirect_cost',
        label: 'despesa fixa Real',
        sortable: false,
      },
      {
        key: 'real_direct_cost',
        label: 'Custo Direto Real',
        sortable: false,
      },
      {
        key: 'finalRealCost',
        label: 'Custo Final Real',
        sortable: false,
      },
    ],
    taxRecordsList: false,
  }),
  computed: {
    allOptions() {
      return [
        {
          member: {
            id: 'all',
          },
          user: { username: 'Todos' },
        },
        ...this.users,
      ];
    },
    tableTotals() {
      const total = {
        estIndCost: 0,
        dirRealCost: 0,
        indRealCost: 0,
        finalEstCost: 0,
        dirEstCost: 0,
        finalRealCost: 0,
        duration: 0,
      };

      this.items.forEach((item) => {
        total.estIndCost += item.indirect_cost || 0;
        total.dirRealCost += item.real_direct_cost || 0;
        total.indRealCost += item.real_indirect_cost || 0;
        total.finalEstCost +=
          (item.indirect_cost || 0) + (item.direct_cost || 0);
        total.dirEstCost += item.direct_cost || 0;
        total.finalRealCost +=
          (item.real_direct_cost || 0) + (item.real_indirect_cost || 0);

        const [startH, startM] = item.start.split(':').map(Number);
        const [endH, endM] = item.end.split(':').map(Number);
        const startMinutes = startH * 60 + startM;
        const endMinutes = endH * 60 + endM;
        total.duration += endMinutes - startMinutes;
      });

      return total;
    },
  },
  async created() {
    await this.getAllUsers();
    await this.getTasksBySelect();
    this.getProject();
  },

  methods: {
    getProject() {
      this.$store
        .dispatch('getProject', {
          id: this.$route.params.id,
          workspace_id: this.$store.getters.currentWorkspace.id,
        })
        .then((resp) => {
          this.project_name = resp.project_name;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    allPeriodSwitch() {
      this.allPeriod = true;
      this.getTasks();
    },
    handleInput(val) {
      const allIds = this.users.map((u) => u.member.id);

      if (val.includes('all')) {
        // Se clicou em 'all', seleciona todos
        this.selectedUsers = allIds;
      } else {
        // Caso contrário, mantém só o que foi selecionado
        this.selectedUsers = val;
      }

      this.getTasksBySelect();
    },
    clearAll() {
      this.selectedUsers = [];
      this.getTasksBySelect();
    },
    getPage(val) {
      this.isBusy = true;
      this.items = [];
      this.$store
        .dispatch('getAllProjectTasks', {
          workspace_id: this.$store.getters.currentWorkspace.id,
          inactive: this.allowInactivates,
          id: this.$route.params.id,
          page: val,
          perPage: 10,
        })
        .then((resp) => {
          this.currentPage = val;

          this.totalRows = resp.pagination.total;
          this.items = resp.data;
          this.isBusy = false;
          if (resp === '') {
            this.items = [];
          }
          this.$nextTick(() => {
            this.$refs.mytab.refresh();
          });
        })
        .catch((err) => {
          console.log(err);
        });
      this.loading = false;
    },
    async getTasksBySelect(val) {
      try {
        const resp = await this.$store.dispatch('getMyBySelect', {
          start_date: this.start_date,
          end_date: this.end_date,
          project_id: this.$route.params.id,
          member_id:
            this.selectedUsers && this.selectedUsers.length > 0
              ? this.selectedUsers.filter((id) => id !== 'all')
              : null,
          workspace_id: this.$store.getters.currentWorkspace.id,
          inactive: this.allowInactivates,
          type: 'select',
          page: val ? val : 1,
          perPage: this.perPage,
        });

        this.dismount = false;
        this.items = resp.data;
        this.totalRows = resp.pagination.total;
        this.events = [];

        if (resp === '') {
          this.items = [];
        }

        this.items.map((dialog) => {
          this.events.push({
            ...dialog,
            color: dialog.member.color,
            project_code: dialog.project.project_code,
            date: dialog.date,
            startTime: dialog.start,
            endTime: dialog.end,
            name: dialog.task_title
              ? dialog.task_title.task_title.toUpperCase()
              : dialog.title,
            comments: dialog.notes,
            username: dialog.member.access.user.username,
          });
        });

        this.dismount = true;
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.items = [];
        this.events = [];
      }
    },
    // async getTasks(val) {
    //   console.log();
    //   this.currentPage = val ? val : 1;
    //   (this.isBusy = true),
    //     this.$store
    //       .dispatch('getAllProjectTasks', {
    //         start_date: this.start_date,
    //         end_date: this.end_date,
    //         member_id:
    //           this.selectedUsers && this.selectedUsers.length > 0
    //             ? this.selectedUsers.filter((id) => id !== 'all')
    //             : null,
    //         workspace_id: this.$store.getters.currentWorkspace.id,
    //       })
    //       .then((resp) => {
    //         this.events = [];

    //         this.items = resp.data;
    //         this.totalRows = resp.pagination.total;

    //         this.items.map((dialog) => {
    //           this.events.push({
    //             ...dialog,
    //             color: dialog.member.color,
    //             project_code: dialog.project.project_code,
    //             project_name: dialog.project.project_name,
    //             date: dialog.date,
    //             startTime: dialog.start,
    //             endTime: dialog.end,
    //             name: dialog.task_title
    //               ? dialog.task_title.task_title
    //               : dialog.title,
    //             comments: dialog.notes,
    //             username: dialog.member.access.user.username,
    //           });
    //         });
    //         //console.log(resp);
    //         this.isBusy = false;
    //         if (resp === '') {
    //           this.items = [];
    //         }
    //         this.dismount = true;
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //       });
    //   this.loading = false;
    // },
    async swtichAllowInactivate(e) {
      this.allowInactivates = e;
      this.idArr = [];
      this.events = [];
      this.items = [];

      await this.getAllUsers();
      await this.getTasksBySelect();
    },
    async getAllUsers() {
      this.selectedUsers = [];
      try {
        const resp = await this.$store.dispatch('getAllWorkspaceMembers', {
          workspace_id: this.$store.getters.currentWorkspace.id,
          inactive: this.allowInactivates,
        });

        if (resp) {
          this.users = resp;
        }

        this.idArr = [];
        this.selectedUsers = [];

        this.users.forEach((user) => {
          this.idArr.push(user.member.id);
          this.selectedUsers.push(user.member.id);
        });
      } catch (err) {
        console.log(err);
      }
    },
    cleanFilter() {
      this.modelTaxRecords.search = '';
    },
    applyDateFilter() {
      this.$store
        .dispatch('getAllProjectTasks', {
          workspace_id: this.$store.getters.currentWorkspace.id,
          inactive: this.allowInactivates,
          id: this.$route.params.id,
          start_date: this.startDateWithDay,
          end_date: this.endDateWithLastDay,
          page: this.currentPage,
          perPage: 20,
        })
        .then((resp) => {
          this.totalRows = resp.pagination.total;
          this.items = resp.data;
          // console.log(resp);
          if (resp === '') {
            this.items = [];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async updateDates() {
      this.startDateWithDay = `${this.start_date}-01`;
      const endDateYear = parseInt(this.end_date.substring(0, 4));
      const endDateMonth = parseInt(this.end_date.substring(5, 7));

      const lastDayOfMonth = new Date(endDateYear, endDateMonth, 0).getDate();

      const formattedMonth =
        endDateMonth < 10 ? `0${endDateMonth}` : endDateMonth;

      this.endDateWithLastDay = `${endDateYear}-${formattedMonth}-${lastDayOfMonth}`;

      this.applyDateFilter(); // Fetch data with updated dates
    },

    openDeleteModal(item) {
      this.modalDeleteSupplier = true;
      this.$store.modalSupplier = item;
    },
    formatMinutesToHours(minutes) {
      const h = Math.floor(minutes / 60);
      const m = minutes % 60;
      return `${h}h ${m}min`;
    },
  },
};
</script>
